import { Col, Row } from "react-bootstrap";

export default function Tabs({ tabs, currentTab, setCurrentTab }) {
  return (
    <Row>
      <Col xs={12}>
        <div className={`tab_slider-alternate`}>
          <div className="tabs_container">
            <ul className="tabs_inner">
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  onClick={() => currentTab !== tab.id && setCurrentTab(tab.id)}
                  className={`btn-outline-light fw-normal px-4 ${
                    currentTab === tab.id && "active fw-bold"
                  }`}
                  disabled={currentTab === tab.id}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Col>
    </Row>
  );
}
